export const SITE_BASE_URL =
  process.env.NEXT_PUBLIC_BASE_URL ?? 'https://newtonik.ru';

export const LOGO_URL =
  'https://storage.yandexcloud.net/newtonik/metadata/logo.png';

export const APP_URLS = {
  signUpBaseUrl: '/sign-up',
  signUpChoosePlanUrl: '/sign-up/choose-plan',
  signUpCreateAccountUrl: '/sign-up/create-account',
  signUpSubscriptionCheckout: '/sign-up/checkout',
  paymentResultUrl: '/payment-result',
  // promoSuccess: '/sign-up/success',
  profileSubscriptionManagement: '/profile/subscription',
  profile: '/profile/general',
  privacyPolicy: '/privacy-policy',
  terms: '/terms'
};

export const SUCCESS_PAGES = [APP_URLS.paymentResultUrl];

export const SIGN_UP_ROUTES = ['create-account', 'payment'];

export const PREMIUM_ROUTES = ['premium'];
export const ACCOUNT_ROUTES = ['profile'];
export const PROTECTED_ROUTES = ['premium', 'profile'];
